<script>
import axios from 'axios';
import utilsService from '@/api/utilsService';

const baseUrl = `${process.env.VUE_APP_INEXLINK_API_URL}/api/v1`;

const analyticsService = {
  // empresaId filtra por la empresa duena de los materiales vistos, no por la empresa del
  // visitante: el vinculo es evento -> producto -> empresa. paisId es el pais de esa misma
  // empresa duena, no el de la bodega donde esta el material ni el del visitante.
  async getSummary(fromIso, toIso, empresaId = null, paisId = null) {
    const params = {};
    if (fromIso) params.from = fromIso;
    if (toIso) params.to = toIso;
    if (empresaId) params.empresa_id = empresaId;
    if (paisId) params.pais_id = paisId;

    const response = await axios.get(`${baseUrl}/analytics/summary`, {
      params,
      headers: {
        'Authorization': `Bearer ${utilsService.getToken()}`,
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  },

  // Detalle detras de una tarjeta de KPI. Usa el mismo rango y los mismos filtros que el
  // resumen, asi el total del modal coincide con el numero de la tarjeta.
  async getDetail({ kpi, fromIso, toIso, empresaId = null, paisId = null, page = 1, limit = 50 }) {
    const params = { kpi, page, limit };
    if (fromIso) params.from = fromIso;
    if (toIso) params.to = toIso;
    if (empresaId) params.empresa_id = empresaId;
    if (paisId) params.pais_id = paisId;

    const response = await axios.get(`${baseUrl}/analytics/detail`, {
      params,
      headers: {
        'Authorization': `Bearer ${utilsService.getToken()}`,
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  },

  // Empresas que tienen productos publicados. Devuelve solo ids: los nombres los resuelve
  // el portal contra SQL, porque esta API no tiene acceso a esa base.
  async getEmpresas() {
    try {
      const response = await axios.get(`${baseUrl}/analytics/empresas`, {
        headers: {
          'Authorization': `Bearer ${utilsService.getToken()}`,
          'Content-Type': 'application/json',
        },
      });
      return (response.data && response.data.data) || [];
    } catch (error) {
      console.error('[analyticsService.getEmpresas]', error.message);
      return [];
    }
  },
};

export default analyticsService;
</script>
